import customHeaders, { getSpace } from '../../common/headers';
import { useDataTable } from '../../common/hooks';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { TableBox, Tabs } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../store/general';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import './ListPromotionVer2.scss';

const btn_tab = [
  { label: 'Все', value: 'all' },
  { label: 'Участвуют', value: 'participate' },
  { label: 'Не участвуют', value: 'not_participate' },
];

const ListPromotionVer2 = ({
  selectedMarketplace,
  selectedApi,
  selectedCategory,
  selectedBrand,
  isTableRequest,
  isReady
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const location = useLocation();

  const activeTab = useParams()['*'];
  const navigate = useNavigate();

  const [pageValue, setPageValue] = useState(btn_tab[0]);

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [date, setDate] = useState(periodWeek());

  const onRedirect = (e) => {
    window.open(e[1], '_blank');
  };

  const fetchTableData = (params, abortController = new AbortController().signal) => {
    if (!pageValue) return;
    if (!selectedApi?.value) return

    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `https://apps0.ecomru.ru:4420/api/v1/marketing/action/table${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;

    const body = JSON.stringify({
      filters: filtersParam,
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      api_id_list: getValueMultiFilter(selectedApi),
      brand_id_list: getValueMultiFilter(selectedBrand),
      category_id_list: getValueMultiFilter(selectedCategory),
      order_param: sort?.[0],
      order_param_direction: sort?.[1],
      mp_id_list: getValueMultiFilter(selectedMarketplace),
      status: pageValue == 'all' ? null : pageValue,
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        setLoading(false)
        if (abortController.signal.aborted) {
          return;
        }
      });
  };

  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  const actionHandler = (e) => {
    const actionId = e?.['action_id'];
    const actionName = e?.['Название акции'];
    const apiNames = selectedApi?.map((el) => el?.label);
    const apiIds = selectedApi?.map((el) => el?.value);

    navigate(
      `/marketing-place/joined-promotions/all?actionId=${actionId}&actionName=${actionName}&api_name=${apiNames?.join(
        ','
      )}&api_id=${apiIds?.join(',')}&mp_id=${selectedMarketplace?.value}`
    );
  };

  useEffect(() => {
    if (!isReady) return;
    resetTable();
    const abortController = new AbortController();
    fetchTableData([], abortController)
    return () => abortController.abort();
  }, [isTableRequest, pageValue]);

  useEffect(() => {
    setPageValue(activeTab);
  }, [activeTab]);

  return (
    <div className="list-promotion-ver2">
      <Tabs
        tabs={btn_tab}
        pageValue={pageValue}
        query={location?.search}
      />

      <TableBox
        {...tableProps}
        ref={paginatorRef}
        paginator={true}
        onRedirect={onRedirect}
        fetchCallback={fetchTableData}
        onAction={(e) => actionHandler(e)}
      />
    </div>
  );
};

export { ListPromotionVer2 };
